// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Avatar, Button, Typography, Card, CardHeader, CardMedia, makeStyles } from '@material-ui/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Internal Dependencies
import { IsEmpty } from '../../../common/checks';
import { getThumbnailFromVideoURL } from '../../../common/util';
import Constants from '../../../common/constants';

const useStyles = makeStyles(() => ({
  media: {
    background:     '#000000',
    height:         200,
    width:          200,
    backgroundSize: 'contain',
    maxWidth:       '100%',
    display:        'flex',
    alignItems:     'center',
  },
  oneLine: { display: 'block', overflow: 'hidden' },
}));

const SortableCardItem = ({ cardItem, active, onChange, onClickRemove }) => {
  const classes = useStyles();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: cardItem.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div style={style}>
      <div ref={setNodeRef} {...attributes} {...listeners}>
        <div className="d-inline-block" style={{ backgroundColor: active ? Constants.Colours.Background : Constants.Colours.White, padding: 10 }}>
          <Card style={{ width: 200, display: 'inline-block' }}>
            {!IsEmpty(cardItem.videos)
              ? (
                <div className={classes.media}>
                  <img
                    src={`${getThumbnailFromVideoURL(cardItem.videos[0])}`}
                    style={{
                      display:   'flex',
                      minHeight: 200,
                      minWidth:  200,
                      maxHeight: 200,
                      maxWidth:  200,
                    }}
                    alt=""
                  />
                </div>
              )
              : (<CardMedia className={classes.media} image={cardItem.images[0] ? cardItem.images[0].display : ''} />)}
            <CardHeader
              title={(
                <div style={{  overflowY: 'hidden' }}>
                  <a style={{ fontSize: 13 }} target="_blank" rel="noreferrer" title="View details" href={`/admin/page/${cardItem.pageId}/post/${cardItem.id}`} className={classes.oneLine}>
                    {cardItem.title}
                  </a>

                  <div className="mt-1" style={{ fontSize: 10, color: Constants.Colours.Background }}>
                    {IsEmpty(cardItem.promoFromDate) ? `${cardItem.promoType} period unspecified` : `${new Date(cardItem.promoFromDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} to ${new Date(cardItem.promoTillDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`}
                  </div>

                  <div style={{ fontSize: 10, marginTop: 5, color: Constants.Colours.Background }}>
                    {`ID: ${cardItem.postId}`}
                  </div>

                  <div className="mt-2 d-flex flex-row align-items-center">
                    <Avatar size="small" alt="logo" src={cardItem.logoUrl} className="mr-2" />
                    <a target="_blank" rel="noreferrer" href={`/admin/page/${cardItem.pageId}`}>
                      <Typography>{cardItem.brand}</Typography>
                    </a>
                  </div>

                  <div style={{ color: Constants.Colours.Background }}>
                    <Typography variant="caption">Set position</Typography>
                    <div className="d-flex flex-row">
                      <Button
                        disableElevation
                        variant={cardItem.positionType === Constants.PositionType.Rotatable ? 'contained' : 'text'}
                        size="small"
                        color={cardItem.positionType === Constants.PositionType.Rotatable ? 'secondary' : 'default'}
                        onClick={() => onChange(cardItem.id, Constants.PositionType.Rotatable)}
                      >
                        {Constants.PositionType.Rotatable}
                      </Button>

                      <Button
                        className="ml-3"
                        disableElevation
                        variant={cardItem.positionType === Constants.PositionType.Fixed ? 'contained' : 'text'}
                        size="small"
                        color={cardItem.positionType === Constants.PositionType.Fixed ? 'secondary' : 'default'}
                        onClick={() => onChange(cardItem.id, Constants.PositionType.Fixed)}
                      >
                        {Constants.PositionType.Fixed}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              subheader={(
                <div className="mt-2 d-flex">
                  <Button style={{ marginLeft: 'auto' }} onClick={() => onClickRemove(cardItem.id)} color="secondary" size="small">Remove</Button>
                </div>
              )}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SortableCardItem;

SortableCardItem.defaultProps = {
  cardItem:      PropTypes.shape(Object),
  active:        PropTypes.bool,
  onChange:      PropTypes.func,
  onClickRemove: PropTypes.func,
};

SortableCardItem.propTypes = {
  cardItem:      {},
  active:        false,
  onChange:      () => {},
  onClickRemove: () => {},
};
